import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { OverlayTrigger, Popover } from 'react-bootstrap-5';
import { faListUl } from '@fortawesome/pro-solid-svg-icons';
import { faBriefcase } from '@fortawesome/pro-solid-svg-icons';

const OverlayButton = ({
  children,
  iconClass,
  hide,
  onOpen,
  onClose,
  rootClose = true,
  useNewIcon = false,
}) => {
  if (!children) return null;

  const columnsPopover = (
    <Popover id="popover-positioned-bottom">
      <Popover.Body>{children}</Popover.Body>
    </Popover>
  );

  return (
    <div className="clickable">
      <OverlayTrigger
        overlay={columnsPopover}
        placement="bottom"
        rootClose={rootClose}
        show={!hide}
        trigger="click"
        onToggle={nextShow => nextShow ? onOpen() : onClose()}
      >
        <FontAwesomeIcon
          className={classNames('folder-icon', iconClass)}
          icon={useNewIcon ? faBriefcase : faListUl}
        />
      </OverlayTrigger>
    </div>
  );
};

OverlayButton.propTypes = {
  children: PropTypes.node,
  hide: PropTypes.bool,
  iconClass: PropTypes.string,
  rootClose: PropTypes.bool,
  useNewIcon: PropTypes.bool,
  onClose: PropTypes.func,
  onOpen: PropTypes.func,
};

export default OverlayButton;
